export default "__VITE_ASSET__BmahW4Fr__"